import * as type  from './mutation-types.js';
import { setCookie } from 'assets/login';

export default {
  [type.PER_KEY](state,data){
    sessionStorage.setItem("needkey8", data);
    setCookie("needkey8", data, 2);
    state.key = data
  },
  [type.GOOD_INFO](state,data){
    state.goodInfo = data
  }
}	
